import React from "react";
import { useNavigate } from "react-router-dom";
import { User, LayoutDashboard, ShieldCheck, Home, LogOut, ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { useAuth } from "../context/AuthContext";
import { AuthImage } from "./FileUpload";

export function AvatarMenu({ dark = false, area }) {
  const { user, isOfficer, logout } = useAuth();
  const nav = useNavigate();
  const go = (to) => () => nav(to);
  const face = dark ? "bg-gold text-slate-950 hover:ring-parchment" : "bg-crimson text-parchment hover:ring-gold";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className={`flex h-10 items-center gap-1 rounded-full pr-1 transition-shadow hover:ring-2 ${face}`} title="Account menu" aria-label="Account menu" data-testid="avatar-menu-trigger">
          <span className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-full font-bold">
            {user?.photo_url ? <AuthImage src={user.photo_url} alt="" className="h-full w-full object-cover" /> : user?.name?.[0]}
          </span>
          <ChevronDown size={14} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56" data-testid="avatar-menu">
        <DropdownMenuLabel className="truncate"><span className="block text-sm">{user?.name}</span><span className="eyebrow text-gold">{user?.role}</span></DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={go("/portal/profile")} data-testid="avatar-menu-profile"><User size={15} className="mr-2" /> My profile</DropdownMenuItem>
        {area !== "portal" && <DropdownMenuItem onClick={go("/portal")} data-testid="avatar-menu-portal"><LayoutDashboard size={15} className="mr-2" /> Member Portal</DropdownMenuItem>}
        {isOfficer && area !== "admin" && <DropdownMenuItem onClick={go("/admin")} className="text-palm" data-testid="avatar-menu-admin"><ShieldCheck size={15} className="mr-2" /> Officer Console</DropdownMenuItem>}
        <DropdownMenuItem onClick={go("/")} data-testid="avatar-menu-home"><Home size={15} className="mr-2" /> Public site</DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={async () => { await logout(); nav("/"); }} className="text-crimson" data-testid="avatar-menu-logout"><LogOut size={15} className="mr-2" /> Sign out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
